export enum AdminProgramTableColumnTitle {
  Name = "Naziv",
  Description = "Opis",
  DropOut = "Drop out",
  Status = "Status",
  Link = "",
  Options = "",
}
